import React, { useEffect, useState } from 'react'
import {Trans} from '@lingui/macro'
import {Button} from 'components/UI/Button/Button'
import {useDispatch, useSelector} from 'react-redux'
import {InputText} from 'components/UI/InputText/InputText';
import { IdRefundsState, typeRefundsFilters } from 'model/dashboardRefunds/dRefundsReducer';
import {  dRefundsSetFiltersAC } from 'model/dashboardRefunds/dRefundsActionCreators';
import DateFilter from 'components/UI/DateFilter/DateFilter';
import { NULL_VALUE, SelectBox, typeValuesListItem } from '../../../../UI/SelectBox/SelectBox';
import { Loader } from '../../../../UI/Loader/Loader';
import { getStoreList } from '../../../../../model/dashboardStores/dStoresAPI';
import { IdStoresStateDataItem } from '../../../../../model/dashboardStores/dStoresReducer';
import { errorGenerator } from '../../../../../model/system/utils';


// Type
export type typeDRefundsFilters = {
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const DRefundsFilters: React.FC<typeDRefundsFilters> = ({setOpenFilterBar, setIsActiveFilters}) => {

    const dispatch = useDispatch()


    const filters = useSelector((state: { dRefunds: IdRefundsState }) => state.dRefunds.filters)

    //cashierNameInput
    const [userNameValue, setUserName] = useState(filters.userName|| '')
    const onChangeCashierId= (e: any) => {
        setUserName(e.target.value)
    }

    // Store
    const [ storeLoader, setStoreLoader ] = useState(false);
    const [ storeList, setStoreList ] = useState<typeValuesListItem[]>([]);
    const [ selectedStoreId, setSelectedStoreId ] = useState<string | null>(NULL_VALUE.id);

    useEffect(() => {
        const setData = async () => {
            setStoreLoader(true);

            const res = await getStoreList({
                filters: { name: null, deleted: false },
                full: false
            });

            if (res.status === 200) {
                setStoreList(res.data.map((item: IdStoresStateDataItem) => ({
                    id: item.id,
                    name: item.name
                })));
            } else {
                errorGenerator(res);
            }

        }

        setData().finally(() => setStoreLoader(false));

        setSelectedStoreId(filters.storeId ? filters.storeId : NULL_VALUE.id);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // to Date
    const [toValue, setToValue] = useState(filters.date?.to ? filters.date.to.substring(0, 10) : '')

    // from Date
    const [fromValue, setFromValue] = useState(filters.date?.from ! ? filters.date.from.substring(0, 10) : '')


    const checkIsChangedFiltersHandler = (newFilters: typeRefundsFilters): boolean => {
        // eslint-disable-next-line eqeqeq
        return !( newFilters.userName == filters.userName
            && newFilters.storeId === filters.storeId
            // eslint-disable-next-line eqeqeq
            && newFilters.date?.to == filters.date?.to && newFilters.date?.from == filters.date?.from )
    }

// Submit form
    const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        let a = fromValue ? (new Date(fromValue).toISOString()).slice(0, -1) + '+00:00' : null
        let b = toValue ? (new Date(toValue).toISOString()).slice(0, 11) + '23:59:59:99.999+00:00' : null

        const newFilters: typeRefundsFilters = {
            date: (a === '' && b === '') ? null : {
                from: a,
                to: b
            },
            userName: userNameValue.trim() === '' ? null : userNameValue.trim(),
            storeId: selectedStoreId === NULL_VALUE.id ? null : selectedStoreId,
        }

        if(checkIsChangedFiltersHandler(newFilters)){
            console.log(newFilters)

            await dispatch(dRefundsSetFiltersAC(newFilters))
            setIsActiveFilters(true)
        }
        setOpenFilterBar(false)
    }

    const onRestoreHandler = () => {
        setToValue('')
        setUserName('')
        setFromValue('')
        setIsActiveFilters(false)
        setSelectedStoreId(NULL_VALUE.id)

        dispatch(dRefundsSetFiltersAC({
            date: null,
            storeId: null,
            userName: null,
        }));
    }

    return (
        <>
            <form onSubmit={(e) => onSubmitHandler(e)}>
                <div className="flex flex-col gap-4">

                    <div className='relative'>
                        <SelectBox
                            valuesList={ storeList }
                            valueId={ selectedStoreId }
                            label={ <Trans>Store</Trans> }
                            setIdValue={ setSelectedStoreId }
                        />
                        { storeLoader && <Loader/> }
                    </div>

                    <div>
                        <InputText id={"cashierId"} label={<Trans>User name</Trans>}
                                   onChange={onChangeCashierId} value={userNameValue}
                                   maxLength={100}
                        />
                    </div>

                    <DateFilter
                        label={<Trans>Date</Trans>}
                        fromValue={fromValue}
                        setFromValue={setFromValue}
                        toValue={toValue}
                        setToValue={setToValue}
                        maxData={`${(new Date()).getUTCFullYear()}-${((new Date()).getUTCMonth() + 1) > 9 ? (new Date()).getUTCMonth() + 1 : '0'+((new Date()).getUTCMonth() + 1) }-${(new Date()).getUTCDate()}`}
                        minData={'2020-01-01'}
                    />

                    <div className="flex flex-col sm:flex-row gap-4 mt-4">
                        <Button buttonClassName="w-full" secondary={true} type="button" label={<Trans>Clear</Trans>}
                                onClick={onRestoreHandler}/>
                        <Button buttonClassName="w-full" type="submit" label={<Trans>Apply</Trans>}/>
                    </div>

                </div>
            </form>
        </>
    )
}
